import gql from 'graphql-tag';

export const linkInspectionServiceRequestMutation = gql`
  mutation LinkInspectionServiceRequest(
    $input: LinkInspectionServiceRequestInput!
  ) {
    linkInspectionServiceRequest(input: $input) {
      success
      newVersion
    }
  }
`;
